import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { money, placeOrder } from "../api";
import { useCart } from "../context/CartContext";

const initial = {
  customer_name: "",
  customer_email: "",
  customer_phone: "",
  shipping_address: "1025 Killian Hill Rd Lilburn GA, 30047 Suite C (pickup)",
  shipping_city: "Lilburn",
  shipping_state: "GA",
  shipping_zip: "30047",
  notes: "",
};

export default function Checkout() {
  const { items, subtotal, clear } = useCart();
  const navigate = useNavigate();
  const [form, setForm] = useState(initial);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!items.length) {
    return <Navigate to="/shop" replace />;
  }

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await placeOrder({
        ...form,
        items: items.map((x) => ({ product_id: x.id, qty: x.qty })),
      });
      clear();
      navigate("/order-success", { state: { orderNumber: data.order_number, total: data.total } });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <h1>Checkout</h1>
          <p>We’ll confirm your order and prepare it for pickup at Aki Mart.</p>
        </div>
      </div>

      <div className="container checkout-grid">
        <div className="form-card">
          <h2>Your details</h2>
          {error && <div className="flash flash-error">{error}</div>}
          <form className="form-grid" onSubmit={submit}>
            <div className="form-group full">
              <label htmlFor="customer_name">Full name</label>
              <input id="customer_name" required value={form.customer_name} onChange={set("customer_name")} />
            </div>
            <div className="form-group">
              <label htmlFor="customer_email">Email</label>
              <input
                id="customer_email"
                type="email"
                required
                value={form.customer_email}
                onChange={set("customer_email")}
              />
            </div>
            <div className="form-group">
              <label htmlFor="customer_phone">Phone</label>
              <input
                id="customer_phone"
                type="tel"
                required
                placeholder="+1 (404) …"
                value={form.customer_phone}
                onChange={set("customer_phone")}
              />
            </div>
            <div className="form-group full">
              <label htmlFor="shipping_address">Address / pickup notes</label>
              <input
                id="shipping_address"
                required
                value={form.shipping_address}
                onChange={set("shipping_address")}
              />
            </div>
            <div className="form-group">
              <label htmlFor="shipping_city">City</label>
              <input id="shipping_city" value={form.shipping_city} onChange={set("shipping_city")} />
            </div>
            <div className="form-group">
              <label htmlFor="shipping_state">State</label>
              <input id="shipping_state" value={form.shipping_state} onChange={set("shipping_state")} />
            </div>
            <div className="form-group">
              <label htmlFor="shipping_zip">ZIP</label>
              <input id="shipping_zip" value={form.shipping_zip} onChange={set("shipping_zip")} />
            </div>
            <div className="form-group full">
              <label htmlFor="notes">Order notes (optional)</label>
              <textarea
                id="notes"
                placeholder="Preferred pickup time, allergies…"
                value={form.notes}
                onChange={set("notes")}
              />
            </div>
            <div className="form-group full">
              <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: "100%" }}>
                {busy ? "Placing order…" : "Place order"}
              </button>
            </div>
          </form>
        </div>

        <aside className="order-summary">
          <h2>Order summary</h2>
          {items.map((item) => (
            <div className="summary-line" key={item.id}>
              <span>
                {item.name} × {item.qty}
              </span>
              <span>{money(item.price * item.qty)}</span>
            </div>
          ))}
          <div className="summary-total">
            <span>Total</span>
            <span>{money(subtotal)}</span>
          </div>
          <p className="pickup-note" style={{ marginTop: "1.25rem" }}>
            Pay in store on pickup unless otherwise arranged.{" "}
            <Link to="/cart">Edit cart</Link>
          </p>
        </aside>
      </div>
    </>
  );
}
